<template>
    <div>
        <h3>Your mission</h3>
        <p>Your mission as Backend Developer is to build an API that <router-link to="/frontend">Frontend GUI</router-link> can consume.</p>
        <ApiOverview></ApiOverview>
    </div>
</template>

<script>
import ApiOverview from '@/components/ApiOverview.vue'

export default {
    name: 'FrontendMission',
    components: {
        ApiOverview
    }
}
</script>